<template>
  <div class="flex-container">
    
    <div class="col mx-1 flex-item-left pl-0 pr-0" >
      <router-link to="/sharing?status=failed">
         <div class="card card-purple-pink text-white">
        <div class="card-body justify-content-between align-items-end">
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.sharingCount}}</div>
            <small><strong>تسهیم انجام نشده</strong></small>
          </div>
           <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
     
    </div>
    <div class="col mx-1 flex-item-left pl-0 pr-0" >
      <router-link to="/sharing?status=corefailed">
         <div class="card card-purple-pink text-white">
        <div class="card-body justify-content-between align-items-end">
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.failedTransferCoreRequestCount}}</div>
            <small><strong>ترنسفر ناموفق</strong></small>
          </div>
           <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
     
    </div>

    <div class="col mx-1 flex-item-left pl-0 pr-0">
      <router-link to="/identifier">
      <div class="card card-purple-blue mb-3 mb-md-0">
        <div
          class="
            card-body
            justify-content-between
            text-white
            align-items-end
          "
        >
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.purcentSettlementCount}}</div>
            <small><strong>تسویه پورسانت</strong></small>
          </div>
          <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
    </div>

    <div class="col mx-1 flex-item-left pl-0 pr-0">
      <router-link to="/undoneRefundsCharges">
      <div class="card card-salmon-pink text-white">
        <div class="card-body justify-content-between align-items-end">
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.unchargedRefundCount}}</div>
            <small><strong>شارژ ریفاند</strong></small>
          </div>
          <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
    </div>
    <div class="col mx-1 flex-item-left pl-0 pr-0">
      <router-link to="/nationalcard">
      <div class="card card-purple-blue mb-3 mb-md-0">
        <div
          class="
            card-body
            justify-content-between
            text-white
            align-items-end
          "
        >
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.unauthorizedUserNationalCardAndSelfieCount}}</div>
            <small><strong>تایید مدارک</strong></small>
          </div>
           <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
    </div>
    <div class="col mx-1 flex-item-left pl-0 pr-0">
      <router-link to="/merchants">
      <div class="card card-blue-green text-white">
        <div class="card-body justify-content-between align-items-center">
          <div class="card-number">
            <div class="h3 m-0 align-items-center">{{loadedNotificationList.unauthorizedPaymentGatewayCount}}</div>
            <small><strong>درگاه تایید نشده</strong></small>
          </div>
          <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
    </div>
    <div class="col mx-1 flex-item-left pl-0 pr-0">
      <router-link to="/tickets">
      <div class="card card-salmon-pink text-white">
        <div class="card-body justify-content-between align-items-center">
          <div class="card-number">
            <div class="h3 m-0 align-items-center">({{loadedNotificationList.workingTicketCount}}){{loadedNotificationList.noteficationCount+loadedNotificationList.workingTicketCount}}</div>
            <small><strong>تیکت خوانده نشده</strong></small>
          </div>
           <div class="card-description align-items-center">
            (در دست بررسی)
          </div>
        </div>
      </div>
      </router-link>
    </div>
     <div class="col mx-1 flex-item-left pl-0 pr-0" >
      <router-link to="/internal-transfer">
         <div class="card card-purple-primary text-white">
        <div class="card-body justify-content-between align-items-end">
          <div class="card-number">
            <div class="h3 m-0">{{loadedNotificationList.countInternalTransfer ? loadedNotificationList.countInternalTransfer : 0}}</div>
            <small><strong>انتقال وجه داخلی</strong></small>
          </div>
          <div class="card-description text-right">
            <br />
          </div>
        </div>
      </div>
      </router-link>
     
    </div>
  </div>
</template>

<script>
import { GET_NOTIFICATION_LIST } from "@/core/services/store/getNotification.module";

export default {
  name: "Notification",
  data() {
    return {};
  },
  computed: {
    loadedNotificationList(){
      return this.$store.getters.loadedNotificationList;
    }
  },
  mounted() {
    this.getNotification();
  },
  methods: {
    getNotification(){
      this.$store.dispatch(GET_NOTIFICATION_LIST);
    }
  }
};
</script>

<style >
.flex-container {
  display: flex;
  /* flex-direction: row; */
flex-wrap: wrap;
  text-align: center;
}

.flex-item-left {
  padding: 10px;
  flex: 150px;
}

/* Responsive layout - makes a one column-layout instead of two-column layout */
/* @media (max-width: 768px) {
  .flex-container {
    flex-direction: column;
  }
}
@media screen and ( max-width: 1483px) {
  .flex-container {
    flex-wrap: wrap;
    display: flex;
    text-align: center;
  }
} */
.card-purple-blue {
  background: linear-gradient(45deg, #6d80fe 0%, #23d2fd 100%);
  box-shadow: 0 5px 20px rgb(35 210 253 / 30%);
}
.card-salmon-pink {
  background: linear-gradient(45deg, #ff998b 0%, #ff6d88 100%);
  box-shadow: 0 5px 20px rgb(255 153 139 / 30%);
}
.card-blue-green {
  background: linear-gradient(45deg, #09afe8 0%, #29f499 100%);
  box-shadow: 0 5px 20px rgb(41 244 153 / 30%);
}
.card-purple-pink {
  background: linear-gradient(45deg, #707cff 0%, #fa81e8 100%);
  box-shadow: 0 5px 20px rgb(250 129 232 / 30%);
}
.card-purple-primary {
  background: linear-gradient(45deg, #5a72da 0%, #91d9e4 100%);
  box-shadow: 0 5px 20px rgb(250 129 232 / 30%);
}

.card {
  border: 0;
  border-radius: 10px;
}
</style>
